import React, { useContext } from "react";
import AuthContext from "../context/AuthContext";
import logo from "./logo.png";
import background from "./background.jpeg";
import "./login.css";

const LoginPage = () => {
  // NEW: Added loginError and setLoginError from context
  const { loginUser, loginError, setLoginError, loginAttempts, cooldown } =
    useContext(AuthContext);

  // NEW: Custom submit handler to clear errors before login
  const handleSubmit = (e) => {
    setLoginError(""); // Clear previous errors
    loginUser(e);
  };

  return (
    <div className="login-container">
      <div className="login-left">
        <img src={background} alt="Background" />
      </div>
      <div className="login-right">
        <div className="login-box">
          <img src={logo} alt="Logo" className="login-logo" />
          <h2 className="login-title">Welcome Back</h2>

          {/* NEW: Error message display */}
          {loginError && <div className="login-error">{loginError}</div>}

          {/* Show attempts */}
          {loginAttempts > 0 && cooldown === 0 && (
            <div className="login-attempts">Attempt {loginAttempts} of 5</div>
          )}

          {/* Show cooldown */}
          {cooldown > 0 && (
            <div className="login-cooldown">
              Please wait {cooldown} seconds before retrying.
            </div>
          )}

          {/* MODIFIED: Changed onSubmit to use custom handler */}
          <form onSubmit={handleSubmit} className="login-form">
            <input
              type="text"
              name="username"
              placeholder="Username"
              required
              className="login-input"
            />
            <input
              type="password"
              name="password"
              placeholder="Password"
              required
              className="login-input"
            />
            <button type="submit" className="login-button">
              Login
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
